// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dsea","top":"styles_top__1nrib"};